/**
 * Maps frontend ComponentTypeFormData to backend CreateComponentTypeRequest
 * Converts camelCase to snake_case for API
 */
export function mapCreateComponentTypeToApiRequest(data) {
    var _a;
    return {
        component_type: {
            type_name_en: data.typeNameEn,
            type_name_es: data.typeNameEs,
            type_name_fr: data.typeNameFr,
            description: data.description,
            category: data.category,
            active: (_a = data.active) !== null && _a !== void 0 ? _a : true,
            field_definitions: data.fieldDefinitions,
            compatible_child_type_ids: data.compatibleChildTypeIds,
            allowed_attachable_types: data.allowedAttachableTypes,
            dnv_type: data.dnvType,
            ep_code: data.epCode,
            ec_type: data.ecType,
            joint_commission_title: data.jointCommissionTitle,
            service_line_abbrs: data.serviceLineAbbrs
        }
    };
}
/**
 * Maps partial frontend ComponentTypeFormData to backend UpdateComponentTypeRequest
 * Only includes fields that are defined in the input data
 * Converts camelCase to snake_case for API
 */
export function mapUpdateComponentTypeToApiRequest(data) {
    const requestData = {
        component_type: {}
    };
    if (data.typeNameEn !== undefined) {
        requestData.component_type.type_name_en = data.typeNameEn;
    }
    if (data.typeNameEs !== undefined) {
        requestData.component_type.type_name_es = data.typeNameEs;
    }
    if (data.typeNameFr !== undefined) {
        requestData.component_type.type_name_fr = data.typeNameFr;
    }
    if (data.description !== undefined) {
        requestData.component_type.description = data.description;
    }
    if (data.category !== undefined) {
        requestData.component_type.category = data.category;
    }
    if (data.active !== undefined) {
        requestData.component_type.active = data.active;
    }
    if (data.fieldDefinitions !== undefined) {
        requestData.component_type.field_definitions = data.fieldDefinitions;
    }
    if (data.compatibleChildTypeIds !== undefined) {
        requestData.component_type.compatible_child_type_ids = data.compatibleChildTypeIds;
    }
    if (data.allowedAttachableTypes !== undefined) {
        requestData.component_type.allowed_attachable_types = data.allowedAttachableTypes;
    }
    if (data.dnvType !== undefined) {
        requestData.component_type.dnv_type = data.dnvType;
    }
    if (data.epCode !== undefined) {
        requestData.component_type.ep_code = data.epCode;
    }
    if (data.ecType !== undefined) {
        requestData.component_type.ec_type = data.ecType;
    }
    if (data.jointCommissionTitle !== undefined) {
        requestData.component_type.joint_commission_title = data.jointCommissionTitle;
    }
    if (data.serviceLineAbbrs !== undefined) {
        requestData.component_type.service_line_abbrs = data.serviceLineAbbrs;
    }
    if (data.supportsIndividualReports !== undefined) {
        requestData.component_type.supports_individual_reports = data.supportsIndividualReports;
    }
    return requestData;
}
/**
 * Maps frontend RecommendedComponentTypeFormData to backend ImportRecommendedComponentTypeRequest
 */
export function mapImportRecommendedComponentTypeToApiRequest(data) {
    return {
        slug: data.slug
    };
}
